import type { ReactNode } from 'react';
import { Icon } from '@/lib/icons';

interface DataPolicySectionProps {
  title: string;
  description?: string;
  items?: string[];
  children?: ReactNode;
}

export function DataPolicySection({ title, description, items, children }: DataPolicySectionProps) {
  return (
    <section className="pt-7">
      <p className="flex items-center gap-3 text-[0.66rem] font-semibold uppercase tracking-[0.26em] text-primary/60">
        {title}
      </p>

      {description && (
        <p className="mt-3 max-w-3xl text-sm leading-7 text-muted-foreground/75 sm:text-base">
          {description}
        </p>
      )}

      {items && items.length > 0 && (
        <div className="rounded-lg border mt-5 divide-y divide-border/30 border-border/40">
          {items.map((item) => (
            <div key={item} className="flex items-start gap-3 py-3 text-sm text-foreground/90">
              <Icon name="checkCircle" className="mt-0.5 h-4 w-4 shrink-0 text-primary/50" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      )}

      {children}
    </section>
  );
}
